import React from "react";
import useFdrStore from "../../../../zustand/fdr.store";
import TmsSelect from "../../tms-select";

const FdrInstitutionSelect = ({ span }) => {
  const {
    setSelectedInstitution,
    selectedInstitution,
    institutionData,
    clearStates,
  } = useFdrStore((state) => {
    return {
      setSelectedInstitution: state.setSelectedInstitution,
      selectedInstitution: state.selectedInstitution,
      institutionData: state.institutionData,
      clearStates: state.clearStates,
    };
  });

  return (
    <TmsSelect
      type="col"
      span={span}
      label="Select a Institution"
      setValue={(e) => {
        setSelectedInstitution(e);
        clearStates(
          [
            "bankAccountData",
            "investmentTypeData",
            "selectedBankAccount",
            "selectedFdr",
          ],
          []
        );
      }}
      selectClass="w-100"
      value={selectedInstitution}
      data={institutionData?.items?.map((item) => {
        return { name: item.name, id: item.id };
      })}
      optional={true}
    />
  );
};

export default FdrInstitutionSelect;
